var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.33594C14.1421 7.33594 17.5 6.21665 17.5 4.83594C17.5 3.45523 14.1421 2.33594 10 2.33594C5.85786 2.33594 2.5 3.45523 2.5 4.83594C2.5 6.21665 5.85786 7.33594 10 7.33594Z",
    stroke: "#67768E",
    strokeWidth: 1.19655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49993 4.83594V16.5026C2.49529 16.9034 2.77977 17.2986 3.32938 17.6551C3.87899 18.0115 4.67762 18.3187 5.65796 18.5507C6.6383 18.7827 7.77161 18.9328 8.96236 18.9882C10.1531 19.0437 11.3664 19.0029 12.4999 18.8693",
    stroke: "#67768E",
    strokeWidth: 1.19655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.83594V7.33594",
    stroke: "#67768E",
    strokeWidth: 1.19655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.668L15 14.8346H18.3333L15.8333 19.0013",
    stroke: "#67768E",
    strokeWidth: 1.19655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.668C2.5012 11.0576 2.77557 11.4417 3.30121 11.7897C3.82685 12.1377 4.58921 12.4399 5.52747 12.6722C6.46573 12.9046 7.5539 13.0606 8.70518 13.1279C9.85645 13.1951 11.039 13.1718 12.1583 13.0596",
    stroke: "#67768E",
    strokeWidth: 1.19655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataManagement);
export default __webpack_public_path__ + "static/media/DataManagement.65b38fb0a850413c7bd91a85678180de.svg";
export { ForwardRef as ReactComponent };